import { record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { RateDetail } from '@mews-commander/data-access';

export const transformDescriptions = (descriptions: RateDetail['descriptions']) =>
    pipe(
        descriptions,
        record.map((value) => value && value.replace(/(?<!\r)\n/g, '\r\n'))
    );
